<template>
  <el-dialog
      ref="details"
      width="66%"
      :visible.sync="visible"
      title="详情"
      :append-to-body="true">
    <el-descriptions border column="2">
      <el-descriptions-item label="活动名称">{{ info.name }}</el-descriptions-item>
      <el-descriptions-item label="活动状态">{{ info.status }}</el-descriptions-item>
      <el-descriptions-item label="创建人">{{ info.createUserName }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
      <el-descriptions-item label="活动时间">{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item>
      <el-descriptions-item label="活动奖励">{{ info.money }}</el-descriptions-item>
      <el-descriptions-item label="参与供应商">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="可用路线">{{ info.lineName }}</el-descriptions-item>
      <el-descriptions-item label="是否可使用优惠券">{{ info.isChooseCoupon=== 0 ? '否' : '是' }}</el-descriptions-item>
      <el-descriptions-item label="互斥">{{ info.isUserCoupon === 0 ? '是' : '否' }}</el-descriptions-item>
      <el-descriptions-item label="审核状态">{{ info.state | stateFilter }}</el-descriptions-item>
      <el-descriptions-item label="审核人">{{ info.auditorName }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
  import { detailsById } from '@/api/marketing/activities-api'
  export default {
    name: "activitiesDetails",
    filters: {
      stateFilter(state) {
        switch (state) {
          case 1:
            return '待审核'
          case 2:
            return '已通过'
          case 3:
            return '未通过'
        }
      }
    },
    data() {
      return {
        visible: false,
        info:{}
      }
    },
    methods: {
      init(row) {
        this.visible = true
        this.info = row
        //this.info.status = row.status
        // this.$nextTick(() => {
        //   detailsById(row.id).then(resp => {
        //     this.info = resp.data
        //   })
        // })
      }
    }
  }
</script>

<style scoped>

</style>
